import React from 'react';
import { Play } from 'lucide-react';
import Link from 'next/link';

interface PersonalizationBannerProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onCustomize?: () => void;
}

const PersonalizationBanner: React.FC<PersonalizationBannerProps> = ({
  title = "Personnalisez votre experience sur RRB !",
  description = "Abonnez-vous à des podcasts, filtrer le contenu qui vous intéresse, et plus encore dans votre espace connecté !",
  buttonText = "Personnaliser mon experience",
}) => {
  const profileConfigs = [
    { size: 'w-24 h-24', color: 'bg-yellow-200', url: '/anim/3.png', zIndex: 1 },
    { size: 'w-32 h-32', color: 'bg-blue-200', url: '/anim/2.png', zIndex: 2 },
    { size: 'w-44 h-44', color: 'bg-pink-200', url: '/anim/1.png', zIndex: 3 },
    { size: 'w-44 h-44', color: 'bg-green-200', url: '/anim/4.png', zIndex: 1 },
    { size: 'w-32 h-32', color: 'bg-purple-200', url: '/anim/5.png', zIndex: 2 },
    { size: 'w-24 h-24', color: 'bg-orange-200', url: '/anim/1.png', zIndex: 3 }
  ];
// 
  return (
    <div className="relative w-full bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-lg shadow-sm overflow-hidden">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 hidden lg:flex items-center -space-x-12">
        {[0, 1, 2].map((index) => (
          <div
            key={`left-${index}`}
            className={`${profileConfigs[index].size} rounded-lg overflow-hidden border-2 border-white ${profileConfigs[index].color}`}
            style={{ zIndex: profileConfigs[index].zIndex }}
          >
            <img
              src={profileConfigs[index].url}
              alt={`Profile ${index + 1}`}
              className="w-full h-full object-cover opacity-80"
            />
          </div>
        ))}
      </div>
      <div className="max-w-2xl mx-auto text-center px-4 lg:px-20">
        <h2 className="text-xl font-semibold text-blue-500 mb-2">
          {title}
        </h2>
        <p className="text-gray-600 mb-6">
          {description}
        </p>
        <Link href="/mon-compte/mes-abonnements">
          <button
            className="inline-flex items-center px-6 py-3 bg-[#004686] text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
            {buttonText}
            <Play className="ml-2 w-4 h-4" />
          </button>
          </Link>
      </div>
      <div className="absolute right-4 top-1/2 -translate-y-1/2 hidden lg:flex items-center -space-x-12">
        {[3, 4, 5].map((index) => (
          <div
            key={`right-${index}`}
            className={`${profileConfigs[index].size} rounded-lg overflow-hidden border-2 border-white ${profileConfigs[index].color}`}
            style={{ zIndex: 6 - profileConfigs[index].zIndex }} 
          >
            <img
              src={profileConfigs[index].url}
              alt={`Profile ${index + 1}`}
              className="w-full h-full object-cover opacity-80"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonalizationBanner;